import React, { Component } from 'react';
import Header from 'components/CoachHeader';
import View from 'components/CoachDashboardView';
import Session from 'components/Session';
import Footer from 'components/MiniFooter';
import { logPageView, initGA } from 'utils/analytics';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import renderIf from 'render-if';
import { CoachRegister } from 'routes/routeNames';
import Loader from 'components/FullScreenLoader';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { coachDashboardSelector } from './redux';

import { getAllRequests, updateConversation, getCoachProfile,
  getDivisionStudents, getFilteredDivisionStudents } from './actions';

class DashboardCoach extends Component {

  static propTypes = {
    attributes: PropTypes.shape(),
    getCoachProfile: PropTypes.func,
    profile: PropTypes.shape(),
    history: PropTypes.shape(),
    isLoading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    attributes: {},
    getCoachProfile: () => {},
    profile: {},
    history: {
      push: () => {},
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      coach_id: '',
    };
    this.tabListener = this.tabListener.bind(this);
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      const zoneinfo = attributes.get('zoneinfo');
      if (!(zoneinfo === 'COACH' || zoneinfo === 'ADMIN')) {
        history.goBack();
      }
      if (attributes.get('profile') === 'PENDING') {
        history.push(CoachRegister);
      } else {
        const id = attributes.get('profile');
        this.props.getCoachProfile(id);
      }
    }
  }

  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.attributes.get('profile') === 'PENDING') {
      this.props.history.push(CoachRegister);
    }
    if (!is(nextProps.attributes, this.props.attributes)) {
      if (nextProps.attributes.size > 0) {
        const id = nextProps.attributes.get('profile');
        this.props.getCoachProfile(id);
      }
    }
    if (is(this.props.profile, nextProps.profile) && nextProps.profile.size > 0) {
      let questionlinkFromProfile = '';
      if (nextProps.profile.get('question_link') !== undefined) {
        questionlinkFromProfile = nextProps.profile.get('question_link');
      } else {
        questionlinkFromProfile = '';
      }
      const newState = {
        name: nextProps.profile.get('name'),
        city: nextProps.profile.get('city'),
        questionLink: questionlinkFromProfile,
        college: nextProps.profile.get('college'),
        sport: nextProps.profile.get('sport'),
        state: nextProps.profile.get('state'),
        teamPageLink: nextProps.profile.get('team_page_link'),
      };
      this.setState(newState);
    }
    if (nextProps.profile.size > 0) {
      const newState = {
        name: nextProps.profile.get('name'),
        city: nextProps.profile.get('city'),
        questionLink: nextProps.profile.get('question_link'),
        college: nextProps.profile.get('college'),
        sport: nextProps.profile.get('sport'),
        state: nextProps.profile.get('state'),
        teamPageLink: nextProps.profile.get('team_page_link'),
        coach_id: nextProps.profile.get('coach_id'),
      };
      this.setState(newState);
    }
  }

  tabListener(tab) {
    this.setState({ tab });
  }

  render() {
    const renderLoadr = renderIf(this.props.isLoading);
    return (
      <div>
        {renderLoadr(<Loader />)}
        <Header tabListener={this.tabListener} {...this.props} {...this.state} usedFor="coachDashboard" />
        <View {...this.props} {...this.state} />,
        <Footer />
      </div>
    );
  }
}


export default
connect(coachDashboardSelector,
  { getAllRequests,
    updateConversation,
    getCoachProfile,
    getDivisionStudents,
    getFilteredDivisionStudents,
  })(Session(DashboardCoach));



// WEBPACK FOOTER //
// ./src/containers/DashBoardCoach/DashboardCoach.js